import React  from 'react';
import PropTypes from 'prop-types';

const innerRadius      = 3;
const strokeWidthOuter = 1;
const strokeWidthInner = innerRadius * 2;
const outerRadius      = strokeWidthInner + strokeWidthOuter;
const centerX          = outerRadius + strokeWidthOuter;
const centerY          = outerRadius + strokeWidthOuter;

class SlickSliderDot extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		const classNames = [];

		if (this.props.animateDot === this.props.index) {
			classNames.push('slick-animate');
		}

		if (this.props.pauseDot === this.props.index) {
			classNames.push('slick-paused');
		}

		return (
			<a className={classNames.join(' ')} onClick={this.props.onClick}>
				<svg className="slick-dot">
					<circle className="slick-dot__outer" r={outerRadius} cx={centerX} cy={centerY} />
					<circle className="slick-dot__inner" r={innerRadius} cx={centerX} cy={centerY} />
				</svg>
			</a>
		);
	}
}

SlickSliderDot.propTypes = {
	animateDot: PropTypes.number,
	index:      PropTypes.number.isRequired,
	onClick:    PropTypes.func.isRequired,
	pauseDot:   PropTypes.number,
};

SlickSliderDot.defaultProps = {
	animateDot: null,
	index:      0,
	onClick:    () => {},
	pauseDot:   null,
};

export default SlickSliderDot;